import { BMEventsType, type PageLoadPerformanceEventConfig } from '../types';

export const isPageLoadConfig = (data: any): data is PageLoadPerformanceEventConfig => {
	return data.type === BMEventsType.PAGE_LOAD;
};
